export const gridTemplate = {
  1: ["watch"],
  2: ["watch", "watch", "beauty"],
  3: ["watch", "watch", "beauty", "watch"],
  4: ["watch", "watch", "beauty", "watch", "watch"],
  5: ["watch", "watch", "watch", "watch", "beauty", "watch"],
  6: ["watch", "watch", "watch", "watch", "beauty", "watch", "watch"],
  7: ["watch", "watch", "watch", "watch", "beauty", "watch", "watch", "watch"],
  8: ["watch", "watch", "watch", "watch", "beauty", "watch", "watch", "watch", "watch", "edito"],
  9: ["watch", "watch", "watch", "watch", "beauty", "watch", "watch", "watch", "watch", "edito", "watch"],
  10: ["watch", "watch", "watch", "watch", "beauty", "watch", "watch", "watch", "watch", "edito", "watch", "watch"],
  11: ["watch", "watch", "watch", "watch", "beauty", "watch", "watch", "watch", "watch", "edito", "watch", "watch", "watch"],
  12: ["watch", "watch", "watch", "watch", "beauty", "watch", "watch", "watch", "watch", "edito", "watch", "watch", "watch", "watch", "beauty"],
  13: ["watch", "watch", "watch", "watch", "beauty", "watch", "watch", "watch", "watch", "edito", "watch", "watch", "watch", "watch", "beauty", "watch"],
  141: [
    "watch",
    "watch",
    "edito",
    "watch",
    "watch",
    "watch",
    "watch",
    "beauty",
    "edito",
    "watch",
    "watch",
    "watch",
    "watch",
    "beauty",
    "watch",
    "watch",
    "watch",
    "watch",
  ],
  142: [
    "edito",
    "watch",
    "watch",
    "watch",
    "watch",
    "beauty",
    "watch",
    "watch",
    "watch",
    "watch",
    "edito",
    "watch",
    "watch",
    "watch",
    "watch",
    "beauty",
    "watch",
    "watch",
  ],
  18: [
    "watch",
    "watch",
    "watch",
    "watch",
    "watch",
    "watch",
    "watch",
    "watch",
    "watch",
    "watch",
    "watch",
    "watch",
    "watch",
    "watch",
    "watch",
    "watch",
    "watch",
    "watch",
  ],
}
